import { useEffect, useRef, useState } from "react";
import { Subscription, UserScheme } from "client-v2";
import { useDispatch, useSelector } from "react-redux";
import { actionsCreators, State } from "../../redux";
import { bindActionCreators } from "redux";
import { useSearchParams } from "react-router";
import Stripe from "stripe";

import WizardContainer, {
	WizardContainerRef,
} from "../../components/container/WizardContainer";
import PaymentMethod from "../../components/section/donation/PaymentMethod";
import InfoView from "./InfoView";

const IbanWizard = (props: Props) => {
	const dispatch = useDispatch();
	const { setShowError } = bindActionCreators(actionsCreators, dispatch);
	const currentUser = useSelector((state: State) => state.user.currentUser);

	const wizard = useRef<WizardContainerRef>(null);

	const view = "change-payment-method";
	const [searchParams, setSearchParams] = useSearchParams();
	const [canEdit, setCanEdit] = useState<string>("sepa");
	const [paymentIntent, setPaymentIntent] = useState<
		Stripe.PaymentIntent | undefined
	>(undefined);
	const [subscription, setSubscription] = useState<
		Stripe.Subscription | undefined
	>(undefined);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		//init
		if (currentUser) {
			//TODO getSubscriptionInfo(currentUser);
		}
	}, [currentUser]);

	// const getSubscriptionInfo = (user: UserScheme) => {
	// 	const id = searchParams.get("id");
	// 	if (id && (id === "card" || id === "sepa")) {
	// 		setCanEdit(id);
	// 	} else {
	// 		//Get the current subscription
	// 		setLoading(true);
	// 		Subscription.get({
	// 			userId: user.objectId,
	// 			limit: 1,
	// 			descending: "createdAt",
	// 		})
	// 			.then((result) => {
	// 				if (result.data.length > 0) {
	// 					const subscription = result.data[0];
	// 					if (subscription.stripeId) {
	// 						setCanEdit("card");
	// 						//Check the subsciption status in Stripe
	// 						Subscription.getStripeStatus(subscription.objectId)
	// 							.then((resultStripe) => {
	// 								const paymentIntent = resultStripe.data
	// 									.invoice
	// 									.payment_intent as Stripe.PaymentIntent;
	// 								const subscription =
	// 									resultStripe.data.subscription;
	// 								setSubscription(subscription);
	// 								if (
	// 									paymentIntent.status === "canceled" ||
	// 									paymentIntent.status ===
	// 										"requires_confirmation" ||
	// 									paymentIntent.status ===
	// 										"requires_action" ||
	// 									paymentIntent.status ===
	// 										"requires_payment_method" ||
	// 									subscription.status === "canceled"
	// 								) {
	// 									setPaymentIntent(paymentIntent);
	// 								} else wizard.current?.goNext();
	// 								setLoading(false);
	// 							})
	// 							.catch((error) => {
	// 								console.error(error.message);
	// 								setLoading(false);
	// 							});
	// 					} else {
	// 						setCanEdit("sepa");
	// 						setLoading(false);
	// 					}
	// 				} else setLoading(false);
	// 			})
	// 			.catch((error) => {
	// 				console.error(error.message);
	// 				setLoading(false);
	// 			});
	// 	}
	// };

	return (
		<WizardContainer
			ref={wizard}
			loading={loading}
			views={[
				//Info view
				{
					centralView: paymentIntent && subscription && (
						<InfoView
							subscription={subscription}
							paymentIntent={paymentIntent}
							onFinish={() => {
								wizard.current?.goNext();
							}}
						/>
					),
				},
				//Select payment method
				{
					centralView: currentUser ? (
						<PaymentMethod
							user={currentUser}
							view={view}
							paymentIntent={paymentIntent}
							canEdit={canEdit as any}
							onFinish={(result) => {
								if (result.error) {
									setShowError({
										show: true,
										message: result.error,
									});
								} else if (result.data) {
									wizard.current?.goNext();
								}
							}}
						/>
					) : null,
				},
			]}
		/>
	);
};
export default IbanWizard;
export interface Props {}
